"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatSpacers = exports.formatBreakpointMods = exports.DataToolbarContext = void 0;

var _reactStyles = require("@patternfly/react-styles");

var _dataToolbar = _interopRequireDefault(require("@patternfly/react-styles/css/components/DataToolbar/data-toolbar"));

var React = _interopRequireWildcard(require("react"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var DataToolbarContext = React.createContext({});
exports.DataToolbarContext = DataToolbarContext;

var formatBreakpointMods = function formatBreakpointMods(breakpointMods) {
  return breakpointMods.reduce(function (acc, curr) {
    return "".concat(acc, " ").concat((0, _reactStyles.getModifier)(_dataToolbar["default"], "".concat(curr.modifier).concat(curr.breakpoint ? "-on-".concat(curr.breakpoint) : '')));
  }, '');
};

exports.formatBreakpointMods = formatBreakpointMods;

var formatSpacers = function formatSpacers(spacers) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'pf-m-spacer';
  return spacers.reduce(function (acc, curr) {
    return "".concat(acc, " ").concat(type, "-").concat(curr.spacerSize).concat(curr.breakpoint ? "-on-".concat(curr.breakpoint) : '');
  }, '');
};

exports.formatSpacers = formatSpacers;